// dbext:profile=staging_mcdo2019_be
import $ from "jquery";

import "./912-admin_multiselect/jquery-ui-1.12.1.min.js";
import "./912-admin_multiselect/jquery.uix.multiselect.min.js";

export default class  {

    init({ select_name, wrapper_class, data })
    {
        this.select_name = select_name;

        this.de_wrapper = $(wrapper_class);

        const id_multiselect_source = 'id-multiselect-source-' + Math.floor( Math.random() * 999999 );

        this.set_html( id_multiselect_source, data );

        // copy the source element into the multiselect to avoid caching,
        // i.e. make sure that the current state is represented
        $('.c-multiselect').empty().html( $('.'+id_multiselect_source).html() ).multiselect({
            moveEffect: 'blind',
            moveEffectOptions: {
                direction: 'vertical'
            },
            moveEffectSpeed: 'fast',
//          sortMethod: 'standard',
            sortMethod: null,
            sortable: true
        });

//      setTimeout(() => {
//          $('.c-multiselect').multiselect().setOption('sortMethod', 'standard');
//      }, 3000 );

    }

    set_html( id_multiselect_source, data )
    {
        var html = 
            `
                <select class="${id_multiselect_source}" multiple="multiple" style="display: none;">

                    ${data.map( ( e ) => 
                        `<option value="${e.value}" ${ (e.selected) ? 'selected="selected"' : '' }>${e.name}</option>`
                    ).join('')}

                </select>

                <select class="c-multiselect" name="${this.select_name}" multiple="multiple">
                </select>

                <link rel="stylesheet" href="/modules/custom/10_mcdo/912-admin-multiselect/jquery-ui.css">
                <link rel="stylesheet" href="/modules/custom/10_mcdo/912-admin-multiselect/jquery.uix.multiselect.css">
                <script>
                </script>
                <style>
                    .c-multiselect {
                        width: 100%;
                        height: 700px;
                    }
                </style>

                <br clear="both">
            `
        ;

        // set this html fragment in the wrapper
        this.de_wrapper.html( html );
    }

}

